module.exports = __webpack_public_path__ + "img/ch09_17_多年后空城.8049f2ff.jpg";